import React from 'react';

export default function ExpenseReportInfoSection({ report }) {
  // Calculate status badge color
  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'approved': return 'bg-green-100 text-green-700';
      case 'paid': return 'bg-emerald-100 text-emerald-700 border border-emerald-300';
      case 'submitted': return 'bg-blue-100 text-blue-700';
      case 'rejected': return 'bg-red-100 text-red-700';
      default: return 'bg-slate-100 text-slate-700';
    }
  };

  // Format currency
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(amount || 0);
  };

  return (
    <div className="mb-4">
      {/* Title */}
      <div className="mb-3 text-center">
        <h2 className="text-lg font-semibold text-slate-900">Weekly Expense Report</h2>
        <p className="text-sm text-slate-500">Week {report.week_number}, {report.year}</p>
      </div>
      
      {/* Info Grid - 3 columns */}
      <div className="grid grid-cols-3 gap-4 text-sm">
        {/* Employee */}
        <div>
          <p className="text-[10px] font-semibold uppercase tracking-wider text-slate-400 mb-1">Employee</p>
          <p className="font-semibold text-slate-900">{report.user_name}</p>
          <span className={`inline-block mt-1 px-2 py-0.5 rounded text-[10px] font-medium ${getStatusColor(report.status)}`}>
            {report.status || 'Draft'}
          </span>
        </div>
        
        {/* Period */}
        <div>
          <p className="text-[10px] font-semibold uppercase tracking-wider text-slate-400 mb-1">Period</p>
          <p className="font-medium text-slate-700">{report.week_start}</p>
          <p className="text-xs text-slate-500">to {report.week_end}</p>
        </div>
        
        {/* Total Amount */}
        <div>
          <p className="text-[10px] font-semibold uppercase tracking-wider text-slate-400 mb-1">Total Amount</p>
          <p className="text-2xl font-bold text-emerald-600">{formatCurrency(report.total_amount)}</p>
        </div>
      </div>
    </div>
  );
}
